import { RightArrowIcon } from "src/assets";
import { Button } from "src/ui/widgets";

import { useSection5 } from "./section5.hook";
import { Image } from "react-bootstrap";

export const Section5 = () => {
  const { logos, t, contactUs, openLogo } = useSection5();

  const PreTitle = (
    <div className="mb-5 d-flex align-items-center justify-content-center">
      <div className="p-2 section5-dynamic-size-pretitle text-uppercase">
        {t("landing.section_5_pre_title")}
      </div>
    </div>
  );

  const Title = (
    <h2 className="mb-4 mb-md-5 px-1 landing-dynamic-size-title text-uppercase text-center text-break d-flex flex-column">
      <span className="d-inline-block">{t("landing.section_5_title_1")}</span>
      <span className="d-inline-block ms-2 c-2727ab">
        {t("landing.section_5_title_2")}
      </span>
    </h2>
  );

  const Subtitle = (
    <div className="mb-5 section5-dynamic-size-subtitle d-flex align-items-center justify-content-center white-space-pre-subtitle text-center">
      {t("landing.section_5_subtitle")}
    </div>
  );

  const ButtonForm = (
    <div className="mb-5 d-flex align-items-center justify-content-center">
      <Button
        text={t("landing.section_5_contact_button")}
        iconRight={RightArrowIcon}
        iconSize={20}
        classes="primary"
        onPress={contactUs}
      />
    </div>
  );

  const Partners = (
    <div>
      <div className="pt-3 mb-5 section5-dynamic-size-partners-title d-flex align-items-center justify-content-center">
        {t("landing.section_5_partners_title")}
      </div>
      <div className="d-flex align-items-center justify-content-md-around">
        <div
          className={`d-flex flex-row flex-wrap col align-items-center justify-content-between`}
        >
          {logos?.map((logo) => (
            <div
              key={logo?.docCode}
              className={`${
                logos?.length !== undefined && logos?.length <= 3
                  ? "col-4 "
                  : "col-md-2 col-6"
              } d-flex align-items-center justify-content-center cursor-pointer`}
              onClick={() => openLogo(logo?.link?.["it"])}
            >
              <Image
                src={logo?.filePath["it"]}
                height="100%"
                className="partner-logo mb-4"
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );

  return (
    <div>
      {PreTitle}
      {Title}
      {Subtitle}
      {ButtonForm}
      {Partners}
    </div>
  );
};
